import {Component, Input} from "@angular/core";

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    providers: [],
    standalone: false
})
export class FaqComponent {
  @Input() textkeyPrefix: string;

  @Input() faqTopics: string[];

}
